// extracted by mini-css-extract-plugin
export default {"header":"ScreenHeader_header__uFl-p","title":"ScreenHeader_title__7plq2","time":"ScreenHeader_time__+M9dC","actions":"ScreenHeader_actions__m-hJ-"};